import { render } from "./Main.vue?vue&type=template&id=b34ed714"
const script = {}
script.render = render

export default script